<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :class="{ disable: formType === 0 ? true : false }">
      <a-form-model-item label="动态标题" prop="dynamicsId" >
        <a-input v-model="form.dynamicsId" placeholder="请输入动态标题" />
      </a-form-model-item>
      <a-form-model-item label="推广模板" prop="popularizeId" >
        <a-input v-model="form.popularizeId" placeholder="请输入推广模板" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-input v-model='form.statusr' placeholder="状态" />
      </a-form-model-item>
      <a-form-model-item label="支付方式" prop="payType" >
        <a-input v-model='form.payTyper' placeholder="支付方式" />
      </a-form-model-item>
      <a-form-model-item label="支付时间" prop="payTime" >
        <a-date-picker style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="推广结束时间" prop="endTime" >
        <a-date-picker style="width: 100%" v-model="form.endTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <!-- <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div> -->
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPopularize, addPopularize, updatePopularize } from '@/api/dynamics/popularize'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        dynamicsId: null,

        popularizeId: null,

        status: 0,

        payType: null,

        payTime: null,

        endTime: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改,0查看
      formType: 1,
      open: false,
      rules: {
        dynamicsId: [
          { required: true, message: '动态ID不能为空', trigger: 'blur' }
        ],
        popularizeId: [
          { required: true, message: '推广模板ID不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' }
        ],
        payType: [
          { required: true, message: '支付方式不能为空', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '推广结束时间不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onStatus(val){
      if(val=='1'){
        return '待支付'
      }
      else if(val=='2'){
        return '已支付'
      }
      else if(val=='3'){
        return '已失效'
      }

    },
    onPayType(val){
      if(val=='1'){
        return '微信'
      }
      else if(val=='2'){
        return '支付宝'
      }
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        dynamicsId: null,
        popularizeId: null,
        status: 0,
        payType: null,
        payTime: null,
        endTime: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.open = true
        this.formTitle = '修改'
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPopularize({"id":id}).then(response => {
        this.form = response.data
     
      
      })
    },
    handleWatch(row,ids){
      this.open = true
        this.formTitle = '查看'
      this.reset()
      this.formType = 0
      const id = row ? row.id : ids
      getPopularize({"id":id}).then(response => {
        this.form = response.data
        this.form.statusr = this.onStatus(this.form.status)
        this.form.payTyper = this.onPayType(this.form.payType)
        console.log(this.form,"form")
   
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePopularize(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPopularize(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.disable {
    pointer-events: none;
}</style>
